<script setup lang="ts">
  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: { type: String },
    header_type: { type: String },
    content: { type: String },
  });
</script>
<template>
  <section>
    <div class="text section-wrapper container">
      <component v-if="header" class="text__header" :is="header_type || 'h2'" v-html="header" />
      <div v-if="content" class="text__content section-typography" v-html="content" />
    </div>
  </section>

</template>
<style lang="scss">
  .text {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    &__content {
      display: flex;
      flex-direction: column;
      gap: 2rem;
    }
  }

  @media (max-width: 992px) {
    .text{
      padding-left: 1rem;
      padding-right: 1rem;
    }

  }

</style>
